module.exports = __webpack_public_path__ + "static/media/Emolga_gaussian2.7b7e2662.png";